import { type ReactNode } from "react";
import { type SxProps, type Theme, Box, styled } from "~/common/mui";

interface GlobalBannerProps {
  children: ReactNode;
  type?: "primary" | "secondary";
  icon?: ReactNode;
  className?: string;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

const VARIANT_STYLES = {
  primary: {
    bgcolor: "success.container",
    color: "success.onContainer",
  },
  secondary: {
    bgcolor: "surface.main",
    color: "text.primary",
  },
} as const;

const StyledRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "bannerType",
})<{ bannerType: "primary" | "secondary" }>(({ theme, bannerType }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(2),
  height: 58,
  ...VARIANT_STYLES[bannerType],
}));

const GlobalBanner = ({ type = "primary", icon, children, className, onClick, sx }: GlobalBannerProps) => {
  return (
    <StyledRoot bannerType={type} className={className} onClick={onClick} sx={sx}>
      {icon}
      <Box>{children}</Box>
    </StyledRoot>
  );
};

export default GlobalBanner;
